function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    if (event.currentTarget.classList.contains('localization-selector')) return;
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    const closeButtonEl = this.querySelectorAll('[class^="ModalClose-"], [id^="ModalClose-"]');
    for (let i = 0; i < closeButtonEl.length; ++i) {
      closeButtonEl[i].addEventListener(
          'click',
          this.hide.bind(this)
      );
    }
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = this.slider.dataset.loop === 'true';
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderProgressBarEl = document.querySelector('#slider-progress-bar');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this), { passive: true });
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    if (this.enableSliderLooping) {
      this.onWheelEvent = this.onWheelEvent.bind(this);
      this.throttleWheelEvent = this.throttleWheelEvent.bind(this);
      this.slider.addEventListener('touchstart', this.initSwipeEvent.bind(this), { passive: true });
      // Could not make touchmove a passive listener due to needing to use preventDefault
      this.slider.addEventListener('touchmove', this.onSwipeEvent.bind(this));
      this.slider.addEventListener('wheel', this.throttleWheelEvent(this.onWheelEvent, 500), { passive: true });
    }
  }

  throttleWheelEvent(fn, wait) {
    let time = Date.now();
    return (e) => {
      // dismiss every wheel event with deltaY less than 4
      if (!e.deltaX || Math.abs(e.deltaX) < 4) return;

      if ((time + wait - Date.now()) < 0) {
        fn(e);
        time = Date.now();
      }
    }
  }

  onWheelEvent(e) {
    if (!e.deltaX) return;
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
      if (this.currentPage === this.totalPages) {
        this.nextButton.click();
      } else if (this.currentPage === 1) {
        this.prevButton.click();
      }
    }
  }

  initSwipeEvent(e) {
    this.xDown = e.touches[0].clientX;
    this.yDown = e.touches[0].clientY;
    this.swipeDefaultPrevented = false;
  }

  /**
   * Notes:
   *   - e.preventDefault was needed to advance a single slide per swipe. It was also needed to make the loop feature work in iOS due to the native "bounce" that happens on scroll.
   *   - I needed to include the e.preventDefault() in the two places to fix preventing the default horizontal scroll on Android
   *       - When I just had the one after checking for a horizontal swipe; iOS was fine, Android was not.
   *       - When setting the variable to use and using it to signal calling preventDefault at the top of the function; iOS was fine, Android was not.
   *       - I needed both for Android, but either one alone was working for iOS
   * @param e
   */
  onSwipeEvent(e) {
    if (this.swipeDefaultPrevented && e.cancelable) {
      e.preventDefault();
    }
    if (!this.xDown || !this.yDown) { return; }
    const xUp = e.touches[0].clientX;
    const yUp = e.touches[0].clientY;
    this.xDiff = this.xDown - xUp;
    this.yDiff = this.yDown - yUp;
    // Check that the touchmove was horizontal as well as e.touches only registered one touch to prevent issues with pinch/zoom
    if (Math.abs(this.xDiff) > Math.abs(this.yDiff) && e.touches.length === 1) {
      if (e.cancelable) {
        e.preventDefault();
      }
      this.swipeDefaultPrevented = true;
      if (this.xDiff > 0) {
        this.nextButton.click();
      } else {
        this.prevButton.click();
      }
    }
    // Reset values.
    this.xDown = null;
    this.yDown = null;
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset) || 1;
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      if (this.sliderProgressBarEl) {
        this.sliderProgressBarEl.style.width = `${100 / this.totalPages}%`
        this.sliderProgressBarEl.style.marginLeft = `${((this.currentPage - 1) / this.totalPages) * 100}%`;
      }
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft < 20) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    const cal = this.sliderItemOffset * (this.totalPages - 1);
    if (this.enableSliderLooping) {
      if (event.currentTarget.name === 'previous' && this.currentPage === 1){
        this.slideScrollPosition = cal;
      } else if (event.currentTarget.name === 'next' && this.currentPage === this.totalPages){
        this.slideScrollPosition = 0;
      }
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateSelectedNameDisplay(e);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.filterVariantMedia();
      this.updateMedia();
      this.updateWebRotate();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  /**
   * By using the currently selected media thumbnail from the previously selected variant (color),
   * find the correct media image id, media image element, and media thumbnail element for the now selected variant (color)
   * @param mediaGallery
   * @returns {{mediaElement: Element, thumbnailElement: Element, id: string | undefined}|null}
   */
  getSelectedVariantActiveMedia(mediaGallery) {
    if (!mediaGallery) return;
    const mediaKey = document.querySelector('fieldset.color input:checked')?.getAttribute('data-media-key');
    const currentActiveThumbnailEl = mediaGallery.querySelector('.thumbnail[aria-current]');
    if (!currentActiveThumbnailEl) return;
    const activeMediaAltIndex = currentActiveThumbnailEl.parentElement.getAttribute('data-variant-media-alt')?.split('vmk_')[1][0];
    if (activeMediaAltIndex && mediaKey) {
      const selectedVariantActiveMediaSelector = `[data-variant-media-alt*="vmk_${activeMediaAltIndex}_${mediaKey}"]`;
      const selectedVariantActiveMediaEl = mediaGallery.querySelector(`.product__media-item${selectedVariantActiveMediaSelector}`);
      const selectedVariantActiveThumbnailEl = mediaGallery.querySelector(`.thumbnail-list__item${selectedVariantActiveMediaSelector}`);
      return {
        id: selectedVariantActiveMediaEl?.getAttribute('data-media-id')?.split(`${this.dataset.section}-`)[1],
        mediaElement: selectedVariantActiveMediaEl,
        thumbnailElement: selectedVariantActiveThumbnailEl,
      };
    }
    return null;
  }

  /**
   * Find all images assigned to a variant and only show the ones assigned to the selected color and Ensure the correct thumbnail shows as active
   * Only images that have been assigned to a variant will have the "data-variant-media-alt" attribute based an the image alt tag containing "vmk_" somewhere in the text
   * Pattern for the alt text in the images is the designated key per variant is: "vmk_{{num_0-9}}_{{metafields.media.key}} {{description}}", example: "vmk_1_rcs_ppb_20828 Front Right")
   * It is currently expected that there will be the same amount of images per variant
   */
  filterVariantMedia() {
    /*
     * Find all images assigned to a variant and only show the ones assigned to the selected color
     */
    if (!this.currentVariant) return;
    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (!mediaGallery || (mediaGallery && !mediaGallery.classList.contains('hide-variant-media'))) return;
    const mediaKey = document.querySelector('fieldset.color input:checked')?.getAttribute('data-media-key');
    document.querySelectorAll('[data-variant-media-alt]').forEach(altMedia => {
      if (altMedia.getAttribute('data-variant-media-alt').indexOf(`${mediaKey}`) > -1) {
        const altMediaDataTarget = altMedia.getAttribute('data-target'); // thumbnail item
        const altMediaDataMediaId = altMedia.getAttribute('data-media-id'); // media item
        const altMediaMediaId = altMediaDataTarget || altMediaDataMediaId;
        const mediaIsFeatured = altMediaMediaId.indexOf(this.currentVariant.featured_media?.id) > -1;
        if (mediaIsFeatured) {
          altMedia.parentElement.prepend(altMedia);
          if (altMediaDataMediaId) {
            altMedia.classList.add('variant-featured-media');
          }
        }
        altMedia.classList.remove('hide');
      } else {
        altMedia.classList.add('hide');
      }
    });
    // Ensure the correct thumbnail shows as active by resetting the mediaGallery pages
    if (mediaGallery?.elements?.viewer?.slider) {
      mediaGallery.elements.viewer.resetPages();
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    const currentVariantMedia = this.getSelectedVariantActiveMedia(mediaGallery);
    const currentVariantMediaId = currentVariantMedia?.id;
    if (!this.currentVariant.featured_media) return;
    const currentActiveThumbnailEl = mediaGallery.querySelector('.thumbnail[aria-current]');
    // TODO: consider making a resetting to slide back to the featured image instead of staying on selected image on variant change (vs checking that the new alt image setup exists)
    const resetToVariantFeaturedMedia = currentVariantMediaId || currentActiveThumbnailEl?.parentElement.classList.contains('thumbnail-360') ? false : true;
    let mediaId;
    if (resetToVariantFeaturedMedia) {
      mediaId = this.currentVariant.featured_media.id;
    } else {
      mediaId = currentVariantMediaId || currentActiveThumbnailEl?.parentElement.getAttribute('data-target')?.split(`${this.dataset.section}-`)[1];
    }
    if (typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${mediaId}`, resetToVariantFeaturedMedia);
    }
    if (resetToVariantFeaturedMedia) {
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (modalContent) {
        const newMediaModal = modalContent.querySelector(`[data-media-id="${mediaId}"]`);
        modalContent.prepend(newMediaModal);
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, #product-form-installment--mobile`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available && typeof pickUpAvailability.fetchAvailability === 'function') {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateSelectedNameDisplay(e) {
    if (!e || !e.target) return;
    const displayText = e.target.getAttribute('data-display-text');
    const selectedParentFieldsetEl = e.target.closest('fieldset');
    if (selectedParentFieldsetEl) {
      const selectedVariantNameEl = selectedParentFieldsetEl.querySelector('.selected-variant-name');
      selectedVariantNameEl.innerText = displayText;
    }
  }

  updateWebRotate() {
    const webRotateMediaEl = document.querySelector('.media-360');
    if (webRotateMediaEl) {
      const mediaKey = document.querySelector('fieldset.color input:checked')?.getAttribute('data-media-key');
      if (mediaKey) {
        const webRotateHost = window.location.host === 'serial1.com' ? 'https://cdn.serial1.com' : 'https://cdn-staging.serial1.com';
        const wr360EmbedEl = document.querySelector('#wr360embed');
        const webRotateXmlUrl = `${webRotateHost}/webrotate/360_assets/${mediaKey}/${mediaKey}.xml`;
        if (wr360EmbedEl) {
          const newConfig = { config: webRotateXmlUrl };
          wr360EmbedEl.setAttribute('data-imagerotator', JSON.stringify(newConfig));
        } else if (typeof global_app !== 'undefined' && global_app.webrotateApi) {
          global_app.webrotateApi.reload(webRotateXmlUrl, null, null,  0);
        }
      } else {
        console.error(`Missing media.key metafield for variant of: ${this.currentVariant.title}`);
      }
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm && typeof productForm.handleErrorMessage === 'function') {
      productForm.handleErrorMessage();
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const priceClass = `.price-${this.dataset.section}`;
        const badgeClass = '.sjs_badges.badge-container.renders-icons';
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const priceDestination = document.querySelectorAll(priceClass);
        const priceSource = html.querySelectorAll(priceClass);
        const badgeDestination = document.querySelectorAll(badgeClass);
        const badgeSource = html.querySelectorAll(badgeClass);
        const specificationsSelectedDetailsDestination = document.getElementById('specifications-selected-details');
        const specificationsSelectedDetailsSource = html.getElementById('specifications-selected-details');

        if (priceSource && priceDestination) {
          priceDestination.forEach((destination, index) => {
            if (priceSource[index]) {
              destination.innerHTML = priceSource[index].innerHTML;
            }
          });
        };

        if (badgeSource && badgeDestination) {
          badgeDestination.forEach((destination, index) => {
            if (badgeSource[index]) {
              destination.innerHTML = badgeSource[index].innerHTML;
            }
          });
        };

        if (specificationsSelectedDetailsSource && specificationsSelectedDetailsDestination) {
          specificationsSelectedDetailsDestination.innerHTML = specificationsSelectedDetailsSource.innerHTML;
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.outOfStock);
        // Update the Affirm as low as messaging price and toggle shipping/payment messages based on availability
        Array.from(document.querySelectorAll('.additional-messaging')).forEach((messageEl) => {
          if (this.currentVariant.available) {
            messageEl.classList.remove('hide');
            if (typeof affirm !== 'undefined' && affirm.ui && typeof affirm.ui.refresh === 'function') {
              messageEl.querySelector('.affirm-as-low-as').setAttribute('data-amount', this.currentVariant.price.toString());
              affirm.ui.refresh();
            }
          } else {
            messageEl.classList.add('hide');
          }
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = Array.from(document.querySelectorAll('.product-form'));
    if (!productForms.length) return;
    productForms.forEach(productForm => {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        addButton.classList.add('disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButton.classList.remove('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    });
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    // Trigger change when loaded
    this.onVariantChange()
  }

  // Overwrite updateOptions method to check for unavailable variants
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    const possibleVariants = this.getVariantData().filter(variant => variant.option1 === this.options[0])
    for (let index = 0; index < possibleVariants.length; index++) {
      const variant = possibleVariants[index]
      const input = document.querySelector(`[value="${variant.option2}"]`);
      if (input) {
        input.setAttribute('data-variant-sku', variant.sku);
        if (!variant.available) {
          input.classList.add('unavailable')
        } else {
          input.classList.remove('unavailable')
        }
      }
    }
    if (typeof window.product_app !== 'undefined' && typeof window.sizeCalculatorApp !== 'undefined') {
      window.product_app.updateCurrentSelection(window.sizeCalculatorApp.getBestSize());
    }
  }
}

customElements.define('variant-radios', VariantRadios);

class RangeWithTicks extends HTMLElement {
  constructor() {
    super();
    this.addTickmarks();
  }

  addTickmarks() {
    const rangeInputEl = this.querySelector('input')
    const min = rangeInputEl.getAttribute('min') || '0';
    const max = rangeInputEl.getAttribute('max') || '0';
    const step = rangeInputEl.getAttribute('step') || '1';
    const tickCount = (parseFloat(max, 10) - parseFloat(min, 10)) / parseFloat(step, 10);
    const tickmarks = document.createElement('div')
    tickmarks.classList.add('tickmarks');
    let tickHtml = '';
    let i;
    for (i = 0; i <= tickCount; i ++) {
      tickHtml += '<span class="tick"></span>';
    }
    tickmarks.innerHTML = tickHtml;
    this.prepend(tickmarks);
  }
}

customElements.define('range-with-ticks', RangeWithTicks);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    sessionStorage.removeItem(compareModalApp?.STORAGE_KEY || 's1_compare_products');
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) {
      if (event.currentTarget.hasAttribute('data-country-selector')) {
        // Empty the cart before switching markets to ensure there are no invalid products in the cart
        fetch(window.routes.cart_clear_url, { method: "POST" })
            .then((response) => {
              form.submit();
            })
            .catch((error) => {
              console.error(error)
            })
      } else {
        form.submit();
      }
    }
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && (event.relatedTarget.nodeName === 'BUTTON' || event.relatedTarget.getAttribute('role') === 'button' || event.relatedTarget.id === 'menu-drawer');
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

window.global_app = {
  getUserAgentDetails: () => {
    const userAgent = navigator.userAgent;
    let browser = '';
    let os = '';
    if (userAgent.match(/edg/i)) {
      browser = 'edge';
    } else if (userAgent.match(/firefox|fxios/i)) {
      browser = 'firefox';
    } else if (userAgent.match(/opr\//i)) {
      browser = 'opera';
    } else if (userAgent.match(/chrome|chromium|crios/i)) {
      browser = 'chrome';
    } else if (userAgent.match(/safari/i)) {
      browser = 'safari';
    }
    if (userAgent.indexOf('Win') != -1) {
      os = 'windows';
    } else if (userAgent.indexOf('Linux') != -1) {
      os = 'linux';
    } else if (userAgent.indexOf('Android') != -1) {
      os = 'android';
    } else if (userAgent.indexOf('like Mac') != -1) {
      os = 'ios';
    } else if (userAgent.indexOf('Mac') != -1) {
      os = 'mac';
    }
    return {
      browser,
      os,
    };
  },
  addUserAgentDetailClasses: () => {
    const bodyEl = document.getElementsByTagName('body')[0];
    const userAgentDetails = global_app.getUserAgentDetails();
    bodyEl.classList.add(userAgentDetails.browser);
    bodyEl.classList.add(userAgentDetails.os);
  },
  setExternalLinksToOpenNewTab: () => {
    const links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      } else if (Shopify.routes.root != '/') {
        // When url contains language and or country code for localization, we need to make sure links contain it too for content that is set in a template block with the HTML type
        const shopifyRoot = Shopify.routes.root.substring(0, Shopify.routes.root.length - 1);
        if (links[i].pathname.indexOf(shopifyRoot) != 0) {
          links[i].pathname = `${shopifyRoot}${links[i].pathname}`
        }
      }
    }
  },
  init: () => {
    global_app.addUserAgentDetailClasses();
    global_app.setExternalLinksToOpenNewTab();
  }
};

function wr360ApiCallback(api, isFullScreen) {
  global_app.webrotateApi = api;
  global_app.webrotateIsFullScreen = isFullScreen;
}

document.addEventListener('DOMContentLoaded', function() {
  global_app.init();
});
